import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { updateObject } from '../../global/utility';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import MediaGridView from '../../global/grid_view/media_grid_view';
import MediaUploadButton from '../media_upload_button/media_upload_button';
import Modal from '../../global/modal/modal';
import logger from '../../global/logger';

class BillboardPlaylistMediaAttachmentView extends Component {

    didClickMedia(media) {
        logger.log("didClickMedia: " + media);
        this.props.didClickMedia(media);
        Modal.dismissModal();
    }
    
    render () {
        return (
            <div>
                <p>Click a media item to attach it to the playlist.</p>
                <MediaGridView items={this.props.media} onSelect={(media) => this.didClickMedia(media)} />
                <div className="flex justify-end"><Button text="Cancel" clickEvent={() => Modal.dismissModal()} /></div>
            </div>
        );
    }
}

export default BillboardPlaylistMediaAttachmentView;